import { configSlice } from '../reducers/config.reducers'

export const { setLocale } = configSlice.actions
